import { render, staticRenderFns } from "./HomeReferrals.vue?vue&type=template&id=f7c3226a"
import script from "./HomeReferrals.vue?vue&type=script&lang=js"
export * from "./HomeReferrals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports